import { createServerFn } from '@tanstack/react-start'
import { getFromS3, listFromS3 } from '../../lib/s3'
import type { Music, MusicListItem } from './musicSchemas'

/**
 * Get list of all music
 */
export const getMusic = createServerFn({ method: 'GET' }).handler(
  async (): Promise<MusicListItem[]> => {
    try {
      const keys = await listFromS3('music/')
      const music: MusicListItem[] = []
      for (const key of keys) {
        if (key && key.endsWith('.json')) {
          const item: Music = await getFromS3(key)
          music.push({
            id: item.id,
            title: item.title,
            artist: item.artist,
          })
        }
      }
      return music.sort((a, b) => a.title.localeCompare(b.title))
    } catch (error) {
      return []
    }
  },
)
